import React, { useState } from 'react'
import { CountrySearchFilters, CountrySearchFormProps } from '../Types/countryTypes'
import SearchFormWrapper, { FieldConfig, SearchFormTypes } from '../../Shared/Components/SearchFormWrapper';

const CountrySearchForm = ({ onSearch }: CountrySearchFormProps) => {
    const [filters, setFilters] = useState({
        name: "",
    })

    const fields: FieldConfig[] = [
        { name: "name", label: "Nazwa kraju", type: SearchFormTypes.input, value: "" },
    ];
    const handleSearch = (values: Record<string, string>) => {
        setFilters(values as unknown as CountrySearchFilters);
        onSearch({
            name: values.name,
        });
    };

    return (
        <SearchFormWrapper
            fields={fields}
            initialValues={filters as unknown as Record<string, string>}
            onSubmit={handleSearch}
        />
    )
}

export default CountrySearchForm